<template>
  <div id="webzine">
    <article class="title py-4 bg-secondary">
      <b-container fluid>
        <b-row class="mx-n3">
          <b-col cols="12" lg="2" class="text-nowrap">
            <h1 class="text-21 text-grey-dark text-lg-32 fw-700 break-keep">
              웹진 '담다'
            </h1>
          </b-col>
          <b-col cols="12" lg="9" class="mt-4 mt-lg-0">
            <p class="pl-3 text-14 text-grey-dark text-lg-16 break-keep lh-200">
              <strong> 인터넷 공간에서 읽을 수 있는 웹진 '담다'</strong>
              <br />
              필자는 마을예술창작소 운영위원회, 공간 활동가, 주민 참여자 등
              마을예술창작소와 관련있는 사람 모두입니다. 이렇게 매번 담는 글들이
              쌓여 언젠가 마을예술창작소를 생생하게 담은 책으로 탄생하게 되는
              날이 오겠지요? 마을예술창작소를 운영하고, 오가고, 아꼈던 모두가
              함께 나누는 우리만의 ‘마을예술’ 이야기를 쭉 만들어 나가고
              싶습니다.
            </p>
          </b-col>
        </b-row>
      </b-container>
    </article>
    <article class="px-md-3 mt-4">
      <div class="d-flex align-items-cetner">
        <div class="mr-0">
          <b-form-select
            v-model="yearSelected"
            :options="yearList"
            class="select-year mt-2"
          >
          </b-form-select>
        </div>
      </div>
      <webzine-list :list="filteredWebzine"></webzine-list>
      <section
        class="err-msg w-100 p-5 text-center"
        v-show="filteredWebzine.length == 0 && yearSelected !== null"
      >
        <h2 class="mt-5 text-20 text-lg-28 text-primary fw-700">
          웹진을 찾을 수 없습니다!
        </h2>
        <p class="mt-2 text-16 text-lg-18 text-grey-dark">
          선택하신 연도에 웹진이 없거나 현재 웹진을 불러올 수 없습니다. <br />
        </p>
        <img
          :src="require('../../assets/character-thumbnail-both.png')"
          class="character-err mt-5"
          alt="갸우뚱"
        />
      </section>
    </article>
  </div>
</template>

<script>
import WebzineList from "@/components/WebzineList";
export default {
  metaInfo() {
    return {
      titleTemplate: "마을예술창작소 | " + "웹진",
    };
  },
  components: {
    WebzineList,
  },
  data() {
    return {
      allWebzine: [],
      yearSelected: null,
      yearList: [
        { value: null, text: "연도를 선택하세요", disabled: true },
        { value: "2021", text: "2021" },
        { value: "2020", text: "2020" },
        { value: "2019", text: "2019" },
        { value: "2018", text: "2018" },
        { value: "2017", text: "2017" },
        { value: "2016", text: "2016" },
        { value: "2015", text: "2015" },
      ],
    };
  },
  computed: {
    filteredWebzine() {
      return this.yearSelected
        ? this.allWebzine.filter(
            (r) => r.createdAt.split("-")[0] == this.yearSelected
          )
        : this.allWebzine;
    },
  },
  methods: {
    loadAllWebzine() {
      this.$db
        .collection("allWebzine")
        .get()
        .then((querySnapshot) => {
          const arr = [];
          querySnapshot.forEach((doc) => {
            const temp = doc.data();
            temp._id = doc.id;
            arr.push(temp);
          });
          this.allWebzine = arr.sort(function(a, b) {
            return new Date(b.createdAt) - new Date(a.createdAt);
          });
        });
    },
  },
  mounted() {
    this.loadAllWebzine();
  },
};
</script>

<style lang="scss" scoped>
.character-err {
  width: 25rem !important;
}

select {
  appearance: none;
  border: 0;
  width: 100%;
  border-bottom: 2px solid #ffda00;
  border-radius: 0;
  &:focus {
    outline: 0;
    border-bottom: 2px solid #ffda00;
    box-shadow: none;
  }
}
</style>
